import React, { forwardRef } from 'react';

import { ButtonBase, ButtonBaseProps, Tooltip, TooltipProps } from '@mui/material';
import { darken, SxProps, Theme } from '@mui/material/styles';

export type TooltipIconButtonProps = {
  title: string;
  sx?: SxProps<Theme>;
  tooltipProps?: Omit<TooltipProps, 'title' | 'children'>;
} & Omit<ButtonBaseProps, 'title' | 'aria-label'>;

export const TooltipIconButton = forwardRef<HTMLButtonElement, TooltipIconButtonProps>(
  ({ title, sx, tooltipProps, children, ...buttonProps }, ref) => {
    return (
      <Tooltip
        title={title}
        {...tooltipProps}
      >
        <ButtonBase
          ref={ref}
          aria-label={title}
          sx={theme => ({
            backgroundColor: 'gx.response',
            height: 48,
            minWidth: 20,
            p: 0,
            borderRadius: 0,
            transition: 'background-color 0.13s ease',
            svg: {
              fontSize: theme.typography.pxToRem(12)
            },
            '&:hover > .MuiSvgIcon-root': {
              color: 'white'
            },
            ':hover': {
              backgroundColor: darken(theme.palette.gx.response, 0.15)
            },
            ...((typeof sx === 'function' ? sx(theme) : sx) as any)
          })}
          {...buttonProps}
        >
          {children}
        </ButtonBase>
      </Tooltip>
    );
  }
);

TooltipIconButton.displayName = 'TooltipIconButton';

export default TooltipIconButton;
